var render = function render() {
  var _setup$user;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _setup.user && _setup.isShowLoyaltyDayDowngradeStatus ? _c('div', {
    class: _vm.$style.DowngradeLoyaltyStatus
  }, [_c(_setup.StatusDowngradeTimer, {
    class: _vm.$style.status,
    attrs: {
      "date": (_setup$user = _setup.user) === null || _setup$user === void 0 || (_setup$user = _setup$user.loyalty) === null || _setup$user === void 0 ? void 0 : _setup$user.date_downgrade_status,
      "label": "до понижения статуса"
    }
  })], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };